<template>
  <StandardResourceService
    v-model="activeTab" :tab-list="tabList" title="石基畅联">
    <OrderRecordsComponent v-if="activeTab==='orderRecord'"></OrderRecordsComponent>
    <ProductUpdateComponent v-else-if="activeTab==='productUpdate'"></ProductUpdateComponent>
    <AssociatedAccountComponent v-else-if="activeTab==='linkAccount'"></AssociatedAccountComponent>
    <HotelPriceRuleComponent v-else-if="activeTab==='priceRule'"></HotelPriceRuleComponent>
  </StandardResourceService>
</template>
<script>
import ProductUpdateComponent from '@/views/resource/shiji/components/ProductUpdateComponent.vue'
import OrderRecordsComponent from '@/views/resource/shiji/components/OrderRecordsComponent.vue'
import AssociatedAccountComponent from '@/views/resource/shiji/components/AssociatedAccountComponent.vue'
import HotelPriceRuleComponent from '@/views/resource/shiji/components/HotelPriceRuleComponent.vue'
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'

export default {
  name: 'Home',
  components: {
    AssociatedAccountComponent,
    HotelPriceRuleComponent,
    StandardResourceService,
    OrderRecordsComponent,
    ProductUpdateComponent
  },
  data() {
    return {
      activeTab: 'linkAccount',
      tabList: [
        { label: '订单记录', key: 'orderRecord' },
        { label: '产品更新', key: 'productUpdate' },
        { label: '关联账号', key: 'linkAccount' },
        { label: '酒店改价规则', key: 'priceRule' }
      ]
    }
  }
}
</script>


<style scoped lang="less">

</style>